
 
export class ExternalFun {

 
    public static  getImageUrl =  (imgId:number)=>
    {
       
          var headId = imgId
          var imgUrl = '@/assets/head/Avatar0.png';
          if(headId == 1)
          {
             imgUrl = require('@/assets/head/Avatar1.png'); 
          }
          else if(headId == 2)
          {
             imgUrl = require('@/assets/head/Avatar2.png'); 
          }
          else if(headId == 3)
          {
             imgUrl = require('@/assets/head/Avatar3.png'); 
          }
          else if(headId == 4)
          {
               imgUrl = require('@/assets/head/Avatar4.png'); 
          }
          else if(headId == 5)
          {
               imgUrl = require('@/assets/head/Avatar5.png'); 
          }
         else if(headId == 6)
         {
             imgUrl = require('@/assets/head/Avatar6.png'); 
         }   
        return imgUrl;
    }

    
}








